import React, { useEffect, useState } from 'react';
import { Avatar, Divider, List, Skeleton } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { errorNotification } from '@/utils/Notification';



interface DataType {
    cid: string;
    tag_no: string;

}

interface ListingsDrawerProps {
    beacon_store_id: number

}

const TechniciansBeaconListing: React.FC<ListingsDrawerProps> = ({ beacon_store_id }) => {
    const [data, setData] = useState<DataType[]>([]);
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()

    const getTechnicianBeacons = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beacons/technicianBeacons?beaconStoreId=${beacon_store_id}`, {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    useEffect(() => {
        getTechnicianBeacons();
    }, [beacon_store_id]);

    return (
        <div
            id="scrollableDiv"
            style={{
                height: 400,
                overflow: 'auto',
                padding: '0 16px',
                border: '1px solid rgba(140, 140, 140, 0.35)',
            }}
        >
            <InfiniteScroll
                dataLength={data?.length ? data.length : 0}
                next={getTechnicianBeacons}
                hasMore={data?.length < 2 ? data?.length < 2 : false}
                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                endMessage={<Divider plain>{`🤐 Total  ${data?.length - 1} beacon(s)`}</Divider>}
                scrollableTarget="scrollableDiv"
            >
                <List
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item key={item.cid}>
                            <List.Item.Meta
                                avatar={""}
                                title={item.cid !== 'NONE' ? item.cid : ''}
                            // description={item.tag_no}
                            />
                            {/* <div>Content</div> */}
                        </List.Item>
                    )}
                />
            </InfiniteScroll>
        </div>
    );
};

export default TechniciansBeaconListing;